import React from 'react';

import get from 'lodash/get';
import { FieldArray } from 'react-final-form-arrays';

import { Box } from '@vk-hr-tek/ui/Box';
import { Divider } from '@vk-hr-tek/ui/Divider';

import { ContentSurveysFormValuesQuestionsSection } from '../../../../types';

import { Answers } from './Answers';
import { Question, QuestionProps } from './Question';

type QuestionsSectionProps = Pick<QuestionProps, 'isEdit'>;

export const QuestionsSection = ({ isEdit }: QuestionsSectionProps) => (
  <FieldArray<ContentSurveysFormValuesQuestionsSection> name="questions">
    {({ fields }) =>
      fields.map((name, index) => (
        <Box
          py="24"
          gap="16"
          key={index}
          radius="l"
          display="flex"
          flexDirection="column"
          bgcolor="bg.greyscale.primary"
        >
          <Question
            isEdit={isEdit}
            questionName={name}
            initialWysiwygInputValue={get(
              fields.value,
              `[${index}].content.data`,
              undefined,
            )}
          />
          <Divider />
          <Answers questionName={name} />
        </Box>
      ))
    }
  </FieldArray>
);
